<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import dayjs from "dayjs";

const props = defineProps({
  time: String,
})

const timeLeft = ref({
  hours: 0,
  minutes: 0,
  seconds: 0,
});
function getTimeLeft() {
  const now = dayjs();
  const end = dayjs(props.time);
  const countdown = dayjs.duration(end.diff(now));

  if (countdown.asSeconds() <= 0) {
    timeLeft.value = {
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
    return;
  }

  timeLeft.value = {
    hours: countdown.hours(),
    minutes: countdown.minutes(),
    seconds: countdown.seconds(),
  };
}

let timer;
onMounted(() => {
  getTimeLeft();
  timer = setInterval(getTimeLeft, 1000);
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>

<template>
  <span class="text-nowrap">
    {{ timeLeft.hours }}h {{ timeLeft.minutes }}m {{ timeLeft.seconds }}s
  </span>
</template>
